export const getDisplayPrice = (stock) => {
  if (!stock) {
    return null;
  }

  const salePrice = Number(stock.salePrice);
  if (stock.onSale && Number.isFinite(salePrice) && salePrice > 0) {
    return salePrice;
  }

  const regularPrice = Number(stock.regularPrice);
  return Number.isFinite(regularPrice) ? regularPrice : null;
};

export const formatCurrency = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return null;
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(numeric);
};

export const formatPercent = (value, digits = 0) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return null;
  }
  return `${numeric.toFixed(digits)}%`;
};
